import React from 'react';
import { styled } from '@mui/material';

export const SubTitleWrapper = styled('div')({
    display: 'flex', 
    width: '100%', 
    justifyContent: 'space-between'
});

export const DateOfBirth = styled('div')({});
